import type { Agent, CreateAgentOptions } from '@lucidtech/las-sdk-browser';

import { create } from '@/hooks/api';
import { JSONType } from '@/utils';

export type AgentId = { agentId: string };

export const {
  getOptions: getAgentOptions,
  listOptions: listAgentsOptions,
  useCreate: useCreateAgent,
  useGet: useGetAgent,
  useList: useListAgents,
  useSuspenseGet: useSuspenseGetAgent,
  useUpdate: useUpdateAgent,
  useDelete: useDeleteAgent,
} = create<Agent, AgentId, CreateAgentOptions>({
  cacheKey: 'agents',
  equal: (agent, id) => Boolean(agent && id?.agentId && agent.agentId === id.agentId),
  createId: (agent) => (agent ? { agentId: agent.agentId } : null),
  create: (client, agent) => client.createAgent(agent),
  delete: (client, id) => client.deleteAgent(id.agentId),
  get: (client, id) => client.getAgent(id.agentId),
  list: (client) => {
    return new Promise((resolve, reject) => {
      client
        .listAgents()
        .then((response: JSONType) => {
          resolve({ data: response.agents, nextToken: response.nextToken });
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  update: (client, id, updates) => client.updateAgent(id.agentId, updates),
});

export const toAgentId = (agentId?: string | null): AgentId | null => {
  return agentId ? { agentId } : null;
};
